/* global angular */

(function () {
    "use strict";

    var app = angular
        .module('app')

        .constant('CONFIG', {
            app: appData,
            api: { prefix: '/api' },
            'mobileMenuMaxWidth': 991
        })

    /*
    .config(['$httpProvider', function ($httpProvider) {
        $httpProvider.defaults.withCredentials = true;
    }]);
    */

}());